import type { BloggerStage } from '@ayub/shared'
import { cn } from '@/lib/utils'
import { BLOGGER_STAGE_META, stageBadgeLabel } from './stageMeta'

/** Jadval "Holat" ustuni va kanban kartochkasidagi bosqich belgisi — ikonka + matn birga. */
export function StageBadge({ stage, className }: { stage: BloggerStage; className?: string }) {
  const meta = BLOGGER_STAGE_META[stage]
  const Icon = meta.icon
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-badge px-2 py-0.5 text-xs font-medium',
        meta.textClass,
        meta.subtleClass,
        className,
      )}
    >
      <Icon size={12} aria-hidden="true" />
      {stageBadgeLabel(stage)}
    </span>
  )
}
